import { UUID } from '@/types';
import { rootDomain } from '@/util/helpers/essential-helpers';
import { useSelector } from 'react-redux';
import { getDashboardState } from '@/features/dashboardShare/store-selectors';
import { useDashboardId, useDatasourceId } from '@/hooks';
import { useGetEmbeddedConfigQuery } from '@/features/dashboard/apiSlice';

export const getEmbedUrl = (
  isPublic: boolean,
  publicId: Maybe<string>,
  publicPin: Maybe<string>,
  dashboardId: UUID,
) => {
  if (isPublic) {
    return `${rootDomain()}/share/dashboard/${publicId}/load.html?pin=${publicPin}`;
  }
  return `${rootDomain()}/embedded/dashboard/${dashboardId}`;
};

export const getEmbedCode = (url: string) => {
  return `<iframe \n style="width: 100%; height: 100%; border: 1px solid #ddd; border-radius: 4px;" \n src="${url}"\n>\n</iframe>`;
};

export const useEmbedDashboard = () => {
  const datasourceId = useDatasourceId();
  const dashboardId = useDashboardId();
  const { publicPin, publicId, isPublic } = useSelector(getDashboardState);

  const embedUrl = getEmbedUrl(isPublic, publicId, publicPin, dashboardId);
  const embedCode = getEmbedCode(embedUrl);
  const { data, isLoading } = useGetEmbeddedConfigQuery({
    datasourceId,
  });
  const isConfigured = data?.redirectUrl;

  return {
    embedUrl,
    embedCode,
    isConfigured,
    isLoading,
  };
};
